export function applyliveChatCustomStyles(options = {}) {
	const {
		primaryColor = '#155EEF',
		textColor = '#1d1d1f',
		backgroundColor = '#ffffff',
		theme = 'light',
	} = options;

	let styleElement = document.getElementById('product7-liveChat-custom-styles');

	if (!styleElement) {
		styleElement = document.createElement('style');
		styleElement.id = 'product7-liveChat-custom-styles';
		document.head.appendChild(styleElement);
	}

	const adjustColor = (hex, percent, alpha = 1) => {
		const normalized = String(hex || '').trim();
		if (!/^#?[0-9a-fA-F]{6}$/.test(normalized)) {
			return normalized || '#000000';
		}

		const num = parseInt(normalized.replace('#', ''), 16);
		const r = Math.max(0, Math.min(255, (num >> 16) + percent));
		const g = Math.max(0, Math.min(255, ((num >> 8) & 0x00ff) + percent));
		const b = Math.max(0, Math.min(255, (num & 0x0000ff) + percent));

		if (alpha < 1) {
			return `rgba(${r}, ${g}, ${b}, ${alpha})`;
		}

		return '#' + ((r << 16) | (g << 8) | b).toString(16).padStart(6, '0');
	};

	const darkSurface = adjustColor(backgroundColor, 12);
	const darkSurfaceAlt = adjustColor(backgroundColor, 20);
	const darkBorder = adjustColor(backgroundColor, 34);

	const isDark = theme === 'dark';

	styleElement.textContent = `
		.liveChat-widget {
			--color-primary: ${primaryColor} !important;
			--color-primary-hover: ${adjustColor(primaryColor, -10)} !important;
		}

		.liveChat-launcher-btn {
			background: ${primaryColor} !important;
		}

		.liveChat-launcher-btn:hover {
			box-shadow: 0 8px 24px ${adjustColor(primaryColor, 0, 0.3)} !important;
		}

		.sdk-btn-primary {
			background: ${primaryColor} !important;
			border-color: ${primaryColor} !important;
		}

		.sdk-btn-primary:hover {
			background: ${adjustColor(primaryColor, -10)} !important;
			border-color: ${adjustColor(primaryColor, -10)} !important;
		}

		.liveChat-compose-send:hover:not(:disabled) {
			background: ${primaryColor} !important;
			border-color: ${primaryColor} !important;
			color: #FFFFFF !important;
		}

		.liveChat-nav-tab.active .liveChat-nav-icon,
		.liveChat-nav-tab.active .liveChat-nav-label {
			color: ${primaryColor} !important;
		}

		.liveChat-home-view::before {
			background: radial-gradient(circle, ${adjustColor(primaryColor, 0, 0.08)} 0%, transparent 70%) !important;
		}

		${
			isDark
				? ''
				: `
		.liveChat-widget {
			--msg-bg: ${backgroundColor} !important;
			--msg-bg-surface: ${adjustColor(backgroundColor, -6)} !important;
			--msg-bg-elevated: ${adjustColor(backgroundColor, -12)} !important;
			--msg-bg-input: ${adjustColor(backgroundColor, -4)} !important;
			--color-text-primary: ${textColor} !important;
			--text-primary: ${textColor} !important;
		}

		.liveChat-panel-content {
			background: ${backgroundColor} !important;
			color: ${textColor} !important;
		}

		.liveChat-view {
			color: ${textColor} !important;
		}
		`
		}
	`;

	console.log('✅ Custom web chat styles applied:', { primaryColor, theme });
}

export function removeliveChatCustomStyles() {
	const styleElement = document.getElementById(
		'product7-liveChat-custom-styles'
	);
	if (styleElement && styleElement.parentNode) {
		styleElement.parentNode.removeChild(styleElement);
	}
}
